import { IntakeLabelCollection } from '../../entities/intake-label.interface';

//use alternateLabel for past employment text
export const AishEmploymentLabels: IntakeLabelCollection = {
  currentlyEmployed: {
    label: 'Are you currently employed?',
    onBehalfLabel: 'Is <<oboName>> currently employed?',
  },
  employedInThePast: {
    label: 'Have you been employed in the past?',
    onBehalfLabel: 'Has <<oboName>> been employed in the past?',
  },
  name: {
    label: 'Employer name',
  },
  employmentType: {
    label: 'Employment type',
  },
  employmentRole: {
    label: 'What is your job/role?',
    onBehalfLabel: 'What is their job/role?',
  },
  employmentRole_Past: {
    label: 'What was your job/role when you worked with this employer?',
    onBehalfLabel: 'What was their job/role when they worked with this employer?',
  },
  employmentResponsibilities: {
    label: 'What are your responsibilities?',
    onBehalfLabel: 'What are their responsibilities?',
  },
  employmentResponsibilities_Past: {
    label: 'What were your responsibilities?',
    onBehalfLabel: 'What were their responsibilities?',
  },
  employmentTypeDescription: {
    label: 'Tell us more about your work arrangement, including how often you work',
    onBehalfLabel: 'Tell us more about their work arrangement, including how often they work',
  },
  employmentTypeDescription_Past: {
    label: 'Tell us more about your work arrangement, including how often you worked',
    onBehalfLabel: 'Tell us more about their work arrangement, including how often they worked',
  },
  startDate: {
    label: 'Start date',
  },
  endDate: {
    label: 'End date',
  },
  reasonForLeaving: {
    label: 'Reason for leaving',
  },
  reasonForLeavingOther: {
    label: 'What was your reason for leaving this job?',
    onBehalfLabel: 'What was their reason for leaving this job?',
  },
  avgHours: {
    label: 'On average how many hours do you work per week?',
    onBehalfLabel: 'On average how many hours do they work per week?',
  },
  avgHours_Past: {
    label: 'On average how many hours did you work per week?',
    onBehalfLabel: 'On average how many hours did they work per week?',
  },
  hasUsedEmploymentServices: {
    label: 'Did you use any employment services or supports to help you find work?',
    onBehalfLabel: 'Did <<oboName>> use any employment services or supports to help them find work?',
  },
  employmentServicesNotUsedExplain: {
    label: 'Tell us why you haven’t tried any employment services or supports',
    onBehalfLabel: 'Tell us why they haven’t tried any employment services or supports',
  },
  employmentServicesUsed: {
    label: 'Select any employment services you used to help you find work',
    onBehalfLabel: 'Select any employment services they used to help find work',
  },
  employmentServicesUsedOther: {
    label: 'What other employment services did you use',
    onBehalfLabel: 'What other employment services did they use',
  },
  willingToWork: {
    label: 'Are you willing to work if given the opportunity?',
    onBehalfLabel: 'Is <<oboName>> willing to work if given the opportunity?',
  },
  willingToWorkExplain: {
    label: 'Tell us why you are not willing to work if given the opportunity',
    onBehalfLabel: 'Tell us why they are not willing to work if given the opportunity',
  },
  stepsTaken: {
    label: 'What steps have you taken to find work that is compatible with your disability?',
    onBehalfLabel: 'What steps have they taken to find work that is compatible with their disability?',
  },
  shareInfo: {
    label:
      'Please share any relevant information about your experience with managing your disability and its impact on your ability to work',
    onBehalfLabel:
      'Please share any relevant information about their experience with managing their disability and its impact on their ability to work',
  },
};

export const AishEmploymentHelperTexts: IntakeLabelCollection = {
  name: {
    label: 'Enter your own name, if you are self-employed',
    onBehalfLabel: 'Enter their name if they are self-employed',
  },
  name_Past: {
    label: 'Enter your own name, if you were self-employed',
    onBehalfLabel: 'Enter their name if they were self employed',
  },
};
